import React from 'react';
import ScrollMenuTo from "../../../../utils/ScrollMenuTo";
import AppConfig from "../../../../services/AppConfig";
import {ReactComponent as MenuItemDarkIco} from "../../../../../images/icons/menus/menu-item-dark.svg";
import {ReactComponent as MenuItemIco} from "../../../../../images/icons/menus/menu-item.svg";
import {useTranslation} from "react-i18next";
import {CategoryViewType, ConfigApi} from "../../../../services/Api/types";
import CategoryHelper from "../../../../services/Menu/services/Category/CategoryHelper";
import StoreUtils from "../../../../services/Store/StoreUtils";

interface Props {
    type: CategoryViewType;
    category: any;
    orderType: string | undefined;
    index: number;
    config: ConfigApi | undefined;
}

const MenuCategoriesNavbarItem = ({type, category, orderType, index, config}: Props) => {
    const {t} = useTranslation();

    const getImage = () => {
        if (category.image_link) return category.image_link.small;

        const sortedCategoryItems = CategoryHelper.getSortedCategoryItems(category);
        const categoryItemImage = sortedCategoryItems
            .map((entity: any) => entity.type === "ITEM_GROUP" ? entity.item?.image_link : entity.image_link)
            .find(Boolean);

        if (categoryItemImage) return categoryItemImage.small;

        return undefined;
    }

    const image = getImage();

    return (
        type === CategoryViewType.BASIC ? (
            <li className="nav-item">
                <ScrollMenuTo to={`category-${orderType}-${category.id}`} sectionMargin={48}
                              isFirstElement={index === 0}
                              productsViewType={StoreUtils.getMenuProductsViewType(config)}>
                    {category.name}
                </ScrollMenuTo>
            </li>
        ) : (
            <li className="nav-item nav-item-with-image">
                <ScrollMenuTo to={`category-${orderType}-${category.id}`} sectionMargin={48}
                              isFirstElement={index === 0}
                              productsViewType={StoreUtils.getMenuProductsViewType(config)}>
                    <div className="d-flex flex-column align-items-center gap-2">
                        <div className="card-img">
                            {
                                image ? <img src={image}
                                             alt={t("modules.menu.field.category_image.title")}/> : AppConfig.isDarkMode() ?
                                    <MenuItemDarkIco/> : <MenuItemIco/>
                            }
                        </div>
                        <p className="mb-0">{category.name}</p>
                    </div>
                </ScrollMenuTo>
            </li>
        )
    )
}

export default MenuCategoriesNavbarItem;